// drawer/tabs/OverviewTab.tsx
import {
  CVSSComponent,
  EPSSComponent,
  TIProviderSummary,
} from '@/sections/threats/drawer/components';
import type { EnrichedVulnerability } from '@/sections/threats/types';

interface OverviewTabProps {
  threatIntel?: EnrichedVulnerability;
}

/**
 * Overview tab content - description, EPSS, and CVSS scores
 */
export function OverviewTab({ threatIntel }: OverviewTabProps) {
  const description = threatIntel?.description || '';

  return (
    <>
      <h3 className="text-chariot-text-primary text-sm">{description}</h3>
      <EPSSComponent threatIntel={threatIntel} />
      <TIProviderSummary threatIntel={threatIntel} />
      <CVSSComponent threatIntel={threatIntel} />
    </>
  );
}
